/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
// 只能输入纯数字的
class NumberEditor {
  editorType = 'Input';
  editorConfig;
  container;
  successCallback;
  element;
  constructor(editorConfig) {
    this.editorConfig = editorConfig
  }

  createElement() {
    const input = document.createElement('input')
    input.setAttribute('type', 'text')
    input.style.position = 'absolute'
    input.style.padding = '4px'
    input.style.width = '100%'
    input.style.boxSizing = 'border-box'
    this.element = input
    this.container.appendChild(input)
    input.addEventListener('keydown', (e) => {
        if (e.key === 'a' && (e.ctrlKey || e.metaKey)) {
            e.stopPropagation()
        }
    })
    input.addEventListener('input', function(event) {
      const target = event.target
      target.value = target.value.replace(/[^\d]/g, '')
    })
  }
  setValue(value) {
    this.element.value = typeof value !== 'undefined' ? value : ''
  }
  getValue() {
    return this.element.value
  }
  onStart({ value, referencePosition, container, endEdit }) {
    this.container = container
    this.successCallback = endEdit
    if (!this.element) {
      this.createElement()
      if (value !== undefined && value !== null) {
          this.setValue(value)
      }
      if (referencePosition?.rect) {
          this.adjustPosition(referencePosition.rect)
      }
    }
    this.element.focus()
  }
  adjustPosition(rect) {
    this.element.style.top = rect.top + 'px'
    this.element.style.left = rect.left + 'px'
    this.element.style.width = rect.width + 'px'
    this.element.style.height = rect.height + 'px'
  }
  onEnd() {
    this.container.removeChild(this.element)
    this.element = undefined
  }
  isEditorElement(target) {
    return target === this.element
  }
}

// 输入数字加小数点的
class PointEditor {
  editorType = 'Input';
  editorConfig;
  container;
  successCallback;
  element;
  constructor(editorConfig) {
    this.editorConfig = editorConfig
  }

  createElement() {
    const input = document.createElement('input')
    input.setAttribute('type', 'text')
    input.style.position = 'absolute'
    input.style.padding = '4px'
    input.style.width = '100%'
    input.style.boxSizing = 'border-box'
    this.element = input
    this.container.appendChild(input)
    input.addEventListener('keydown', (e) => {
        if (e.key === 'a' && (e.ctrlKey || e.metaKey)) {
            e.stopPropagation()
        }
    })
    input.addEventListener('input', function(event) {
      const target = event.target
      target.value = target.value.replace(/[^-\d.]/g, '')
      if (target.value === '' || target.value === '.') {
        target.value = '' // 如果输入为空或仅为小数点，则清空
      }
    })
  }
  setValue(value) {
    this.element.value = typeof value !== 'undefined' ? value : ''
  }
  getValue() {
    return this.element.value
  }
  onStart({ value, referencePosition, container, endEdit }) {
    this.container = container
    this.successCallback = endEdit
    if (!this.element) {
      this.createElement()
      if (value !== undefined && value !== null) {
          this.setValue(value)
      }
      if (referencePosition?.rect) {
          this.adjustPosition(referencePosition.rect)
      }
    }
    this.element.focus()
  }
  adjustPosition(rect) {
    this.element.style.top = rect.top + 'px'
    this.element.style.left = rect.left + 'px'
    this.element.style.width = rect.width + 'px'
    this.element.style.height = rect.height + 'px'
  }
  onEnd() {
    this.container.removeChild(this.element)
    this.element = undefined
  }
  isEditorElement(target) {
    return target === this.element
  }
}

class TextareaEditor {
  editorType = 'Textarea';
  editorConfig;
  container;
  successCallback;
  element;
  constructor(editorConfig) {
    this.editorConfig = editorConfig
  }

  createElement() {
    const textarea = document.createElement('textarea')
    textarea.style.position = 'absolute'
    textarea.style.padding = '4px'
    textarea.style.width = '100%'
    textarea.style.boxSizing = 'border-box'
    // textarea.style.resize = 'none' // 禁止用户调整大小
    this.element = textarea
    this.container.appendChild(textarea)
    textarea.addEventListener('keydown', (e) => {
      if (e.key === 'a' && (e.ctrlKey || e.metaKey)) {
        e.stopPropagation()
      }
    })
  }

  setValue(value) {
    this.element.value = typeof value !== 'undefined' ? value : ''
  }

  getValue() {
    return this.element.value
  }

  onStart({ value, referencePosition, container, endEdit }) {
    this.container = container
    this.successCallback = endEdit
    if (!this.element) {
      this.createElement()
      if (value !== undefined && value !== null) {
        this.setValue(value)
      }
      if (referencePosition?.rect) {
        this.adjustPosition(referencePosition.rect)
      }
    }
    this.element.focus()
  }

  adjustPosition(rect) {
    this.element.style.top = rect.top + 'px'
    this.element.style.left = rect.left + 'px'
    this.element.style.width = rect.width + 'px'
    this.element.style.height = rect.height + 'px'
  }

  onEnd() {
    this.container.removeChild(this.element)
    this.element = undefined
  }

  isEditorElement(target) {
    return target === this.element
  }
}

class SelectEditor {
  editorType = 'Select';
  input;
  datalist;
  editorConfig;
  container;
  element;
  successCallback;
  constructor(editorConfig) {
    this.editorConfig = editorConfig
  }

  createElement(value) {
    const input = document.createElement('input')
    input.setAttribute('list', 'options')
    input.setAttribute('type', 'text')
    input.style.position = 'absolute'
    input.style.padding = '4px'
    input.style.width = '100%'
    input.style.boxSizing = 'border-box'
    this.input = input
    this.container.appendChild(input)

    const datalist = document.createElement('datalist')
    datalist.id = 'options'
    const { values } = this.editorConfig
    values.forEach(item => {
      const option = document.createElement('option')
      option.value = item
      datalist.appendChild(option)
    })
    this.datalist = datalist
    this.container.appendChild(datalist)

    input.addEventListener('input', (e) => {
      const filterValue = e.target.value.toLowerCase()
      const options = datalist.options
      for (let i = 0; i < options.length; i++) {
        const option = options[i]
        option.hidden = filterValue && option.value.toLowerCase().indexOf(filterValue) === -1
      }
    })

    input.addEventListener('change', () => {
      this.successCallback(this.input.value)
    })

    if (value !== undefined && value !== null) {
      this.input.value = value
    }
  }

  setValue(value) {
    this.input.value = value
  }

  getValue() {
    return this.input.value
  }

  onStart({ container, value, referencePosition, endEdit }) {
    this.container = container
    this.successCallback = endEdit
    this.createElement(value)
    if (referencePosition?.rect) {
      this.adjustPosition(referencePosition.rect)
    }
    this.input.focus()
  }

  adjustPosition(rect) {
    this.input.style.top = rect.top + 'px'
    this.input.style.left = rect.left + 'px'
    this.input.style.width = rect.width + 'px'
    this.input.style.height = rect.height + 'px'
  }

  onEnd() {
    this.container.removeChild(this.input)
    this.container.removeChild(this.datalist)
    this.input = undefined
    this.datalist = undefined
  }

  isEditorElement(target) {
    return target === this.input
  }
}

module.exports = {
  default: NumberEditor,
  PointEditor,
  TextareaEditor,
  SelectEditor
}
